export const OFFERS_NAMES = [
	{
		id: "offer1",
		name: "Analiza czasu pracy kierowcy",
		linkPath: "analiza-czasu-pracy-kierowcow",
	},
	{
		id: "offer2",
		name: "Ocena ryzyka wystąpienia naruszeń",
		linkPath: "ocena-ryzyka-wystapienia-naruszen",
	},
	{
		id: "offer3",
		name: "Pobieranie danych z tachografów i kart",
		linkPath: "pobieranie-danych-z-tachografow",
	},
	{
		id: "offer4",
		name: "Regulamin pracy kierowców",
		linkPath: "regulamin-pracy-kierowcow",
	},
	{
		id: "offer5",
		name: "Rozliczenie czasu pracy kierowców",
		linkPath: "rozliczenie-czasu-pracy-kierowcow",
	},
	{
		id: "offer6",
		name: "Rozliczanie krajowych delegacji kierowców",
		linkPath: "delegacje",
	},
	{
		id: "offer7",
		name: "Szkolenia kierowców zawodowych",
		linkPath: "szkolenia-dla-kierowcow",
	},
	{
		id: "offer8",
		name: "Wyrównanie odszkodowań komunikacyjnych i majątkowych",
		linkPath: "wyrownanie-odszkodowan-komunikacyjnych-majatkowych",
	},
	{
		id: "offer9",
		name: "Zarządzanie środkami transportów",
		linkPath: "zarzadzanie-srodkami-transportu",
	},
	{
		id: "offer10",
		name: "Ewidencja czasu pracy kierowcy",
		linkPath: "ewidencja-czasu-pracy-kierowcy",
	},
];
